
const initialState = {
    isLoading: false,
    success: false,
    error: null
}

const isLoadingReducer = state => ({
    ...state,
    error: null,
    isLoading: true,
    success: false
});

const successReducer = (state,action) => ({
    ...state,
    ...action.payload,
    error: null,
    isLoading: false,
    success: true
  });

const errorReducer = (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
    success: false
});

const noopReducer = state => state;



const fetchStateReducer = (actionTypes) => {

    if(actionTypes == null){
        throw new Error('actionTypes is requiered');
    }

    const actionReducerMap = {
        [actionTypes.isLoadingActionType]: isLoadingReducer,
        [actionTypes.successActionType]: successReducer,
        [actionTypes.errorActionType]: errorReducer
    }

    // if(baseReducer == null){
    //     throw new Error('reducer is requiered');
    // }

    return baseReducer => (state,action) => {

        const reducerFunction = actionReducerMap[action.type] || noopReducer;
        // compute new state with the specificed reducer set in reducerAction
        const newState = reducerFunction(state ? state : initialState, action);
        // return the result of the newState and action passed into the baseReducer

        return baseReducer(newState, action);

    }

}

export default fetchStateReducer;